import { PAGE_KEY } from './constants';

export const es = {
  [PAGE_KEY]: {
    // SEO
    SEO_TITLE: 'Detalle de colaborador | Alertas legales México | Crehana',
    SEO_DESCRIPTION:
      'Consulta el desglose semanal de horas extra de un colaborador frente a los topes legales de México.',

    // Header
    HEADER_TITLE: 'Detalle de colaborador',
    HEADER_TITLE_WITH_NAME: 'Detalle de colaborador: {{name}}',
    BUTTON_BACK: 'Volver',

    // Week navigator
    WEEK_NAVIGATOR_LABEL: 'Semana del {{start}} al {{end}}',
    WEEK_NAVIGATOR_PREV: 'Semana anterior',
    WEEK_NAVIGATOR_NEXT: 'Semana siguiente',
    // date-fns pattern for the {{end}} value above — LOCALE COPY, not a
    // constant. Same MR !257 rationale as EDIT_WORKDAY_DIALOG_TITLE_DATE_PATTERN:
    // `format` localizes `MMMM` but prints quoted segments verbatim, so the
    // "de" connector needs its own value per locale.
    WEEK_NAVIGATOR_END_DATE_PATTERN: "d 'de' MMMM, yyyy",
    // Pattern for the {{start}} value when the week crosses two months (the
    // bare day alone would read as if both ends were in the same month).
    WEEK_NAVIGATOR_START_DATE_PATTERN_CROSS_MONTH: "d 'de' MMMM",

    // State labels
    STATE_NO_ALERTS: 'Sin alertas',
    STATE_AT_RISK: 'En riesgo',
    STATE_EXCEEDED: 'Excedido',
    STATE_NO_DATA: 'Sin datos',

    // Table
    DETAIL_TABLE_TITLE: 'Detalle de alertas',

    // Columns
    COL_DATE: 'Fecha',
    COL_SHIFT: 'Turno del día',
    COL_WORKED_TIME: 'Tiempo trabajado',
    COL_EXTRA_TIME: 'Tiempo extra',
    COL_COMPENSATED_TIME: 'Tiempo de compensación',
    COL_STATE: 'Estado',

    // Rows
    CAP_LABEL: 'Tope: {{value}}',
    // !402 review, hilo DOS — a PROPOSAL, pending Laura's confirmation. Do
    // not mark this copy as approved.
    CAP_LABEL_NOT_EVALUATED: 'Tope legal: {{value}}',
    ROW_TOTAL: 'Total de la semana',
    TODAY_LABEL: 'Hoy',
    EMPTY_VALUE: '—',

    // Errors
    FORBIDDEN_TITLE: 'No tienes acceso',
    FORBIDDEN_DESCRIPTION: 'No cuentas con permiso para ver esta información.',
    NOT_AUTHENTICATED_TITLE: 'Tu sesión no es válida',
    NOT_AUTHENTICATED_DESCRIPTION:
      'Inicia sesión de nuevo para ver el detalle del colaborador.',
    VALIDATION_TITLE: 'El colaborador no es válido',
    VALIDATION_DESCRIPTION:
      'Revisa el enlace o vuelve a la lista de alertas legales.',
    BUTTON_BACK_TO_LIST: 'Volver a la lista',
    ERROR_TITLE: 'Ocurrió un error',
    ERROR_DESCRIPTION:
      'Ocurrió un error. Haz clic en el botón para reintentar cargar nuevamente.',
    ERROR_RETRY: 'Reintentar',
  },
};
